import {useIntl} from 'react-intl'
import {UpdateOptions, toast} from 'react-toastify'

import ExportReportBtn from 'src/feature/bite/component/ExportReportBtn'

/* import { exportAllCsv } from 'src/feature/bite/helpers/exportCsv';
import { exportAllExcel } from 'src/feature/bite/helpers/exportExcel'; */

/* import { useGetAll } from '../../context/useMutation'; */
import {useExportAll} from 'src/feature/tasks/context/useMutation'

function Dashboard({tableName}: {tableName: string}) {
  const intl = useIntl()
  /*  const { mutateAsync } = useGetAll() */
  const {mutateAsync} = useExportAll(4)

  const toastSuccess: UpdateOptions = {
    render: intl.formatMessage({id: 'GLOBAL.EXPORT.SUCCESS.PROGRESS'}),
    type: 'success',
    isLoading: false,
    autoClose: 5000,
    closeOnClick: true,
  }

  const toastLoading = intl.formatMessage({id: 'GLOBAL.EXPORT.LOADING'})

  const getAllCsv = async () => {
    const toastId = toast.loading(toastLoading)
    const data = await mutateAsync(1)

    toast.update(toastId, toastSuccess)
  }

  const getAllExcel = async () => {
    const toastId = toast.loading(toastLoading)
    const data = await mutateAsync(2)

    toast.update(toastId, toastSuccess)
  }

  return (
    <>
      <ExportReportBtn
        exportTable={tableName}
        exportAllCsv={getAllCsv}
        exportAllExcel={getAllExcel}
      />
    </>
  )
}

export default Dashboard
